module.exports = __webpack_public_path__ + "mailing.png?73c6f24cb2ed8a3c2f0cad93b92ee6b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mailing.png
// module id = 746
// module chunks = 0